(function () {
  var root = document.querySelector('[data-rof-collab]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-rof-node]'));
  var syncing = false;

  function pauseMedia(node) {
    node.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function playMedia(node) {
    if (reduce) return;
    node.querySelectorAll('video').forEach(function (video) {
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    });
  }

  function syncHash(node, isOpen) {
    if (!window.history || !window.history.replaceState) return;
    var url = window.location.pathname + window.location.search;
    if (isOpen && node.id) url += '#' + node.id;
    window.history.replaceState(null, '', url);
  }

  function keepSummaryStable(summary, beforeTop) {
    var afterTop = summary.getBoundingClientRect().top;
    var delta = afterTop - beforeTop;
    if (Math.abs(delta) > 1) {
      window.scrollBy(0, delta);
    }
  }

  function setOpen(node, shouldOpen, summary) {
    var beforeTop = summary ? summary.getBoundingClientRect().top : null;

    syncing = true;
    nodes.forEach(function (other) {
      if (other === node) return;
      if (other.open) {
        other.open = false;
        pauseMedia(other);
      }
    });

    node.open = shouldOpen;
    syncing = false;

    if (shouldOpen) {
      playMedia(node);
      syncHash(node, true);
    } else {
      pauseMedia(node);
      if (window.location.hash === '#' + node.id) syncHash(node, false);
    }

    if (summary && beforeTop != null) {
      // Double rAF: wait for details layout + images reflow after collapse
      requestAnimationFrame(function () {
        keepSummaryStable(summary, beforeTop);
        requestAnimationFrame(function () {
          keepSummaryStable(summary, beforeTop);
        });
      });
    }
  }

  nodes.forEach(function (node) {
    var summary = node.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', function (event) {
      // Take full control so native exclusive-accordion + tall collapse
      // cannot steal the click or jump the scroll position.
      event.preventDefault();
      setOpen(node, !node.open, summary);
    });

    node.addEventListener('toggle', function () {
      if (syncing) return;
      // Keyboard / programmatic opens still pause media + sync hash
      if (node.open) {
        nodes.forEach(function (other) {
          if (other !== node && other.open) {
            syncing = true;
            other.open = false;
            syncing = false;
            pauseMedia(other);
          }
        });
        playMedia(node);
        syncHash(node, true);
      } else {
        pauseMedia(node);
        if (window.location.hash === '#' + node.id) syncHash(node, false);
      }
    });
  });

  function openFromHash() {
    var id = window.location.hash.slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target || !target.hasAttribute('data-rof-node')) return;
    var summary = target.querySelector('summary');
    setOpen(target, true, summary);
  }

  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target && event.target.querySelector
      ? event.target.querySelector('[data-rof-node]')
      : null;
    if (!details && event.target && event.target.hasAttribute && event.target.hasAttribute('data-rof-node')) {
      details = event.target;
    }
    if (details) {
      var summary = details.querySelector('summary');
      setOpen(details, true, summary);
    }
  });

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href').slice(1);
      var target = id ? document.getElementById(id) : null;
      if (!target || !target.hasAttribute('data-rof-node')) return;
      e.preventDefault();
      var summary = target.querySelector('summary');
      setOpen(target, true, summary);
      // Soft align after open settles — never jump to page bottom
      requestAnimationFrame(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: reduce ? 'auto' : 'smooth'
        });
      });
    });
  });

  var banner = root.querySelector('[data-rof-banner]');
  if (banner) {
    if (reduce) {
      banner.removeAttribute('autoplay');
      banner.pause();
    } else {
      var play = banner.play();
      if (play && play.catch) play.catch(function () {});
    }
  }
})();
